export default class ViewFinderManager
{
    constructor()
    {
        this.pointerGrow = document.getElementById("pointerGrow");
        this.pointerShrink = document.getElementById("pointerShrink");
        this.isPointerBig = false;
    }

    onActionStart() 
    {
		try {
            if(!this.isPointerBig)
            // console.log('action started');
            this.pointerGrow.beginElement();

			this.isPointerBig = true;
        } catch(error) 
        {
			console.error(error);
		}
	}

    onActionEnd() 
    {
		try {
			if(this.isPointerBig)
            this.pointerShrink.beginElement();

            this.isPointerBig = false;
        } catch(error) 
        {
			console.error(error)
		}
	}
}